import { UpsCustomerStoreEventHandler } from './UpsCustomerStoreEventHandler';
import {
    ICustomerStoreEventHandler,
    ParcelScannedParameters,
    ParcelStoreCancelledParameters, SendReceiptConfirmedParameters
} from './ICustomerStoreEventHandler';
import {DhlCustomerStoreEventHandler} from "./DhlCustomerStoreEventHandler";

export class CustomerStoreEventHandler implements ICustomerStoreEventHandler {
    async parcelScanned(params: ParcelScannedParameters): Promise<void> {
        switch (params.carrierId) {
            case "ups":
                await new UpsCustomerStoreEventHandler().parcelScanned(params);
                break;
            case "dhl":
                await new DhlCustomerStoreEventHandler().parcelScanned(params);
                break;
        }
    }

    async parcelStoreCancelled(params: ParcelStoreCancelledParameters): Promise<void> {
        switch (params.carrierId) {
            case "ups":
                await new UpsCustomerStoreEventHandler().parcelStoreCancelled(params);
                break;
        }
    }

    async sendReceiptConfirmed(params: SendReceiptConfirmedParameters): Promise<void> {
        switch (params.carrierId) {
            case "ups":
                await new UpsCustomerStoreEventHandler().sendReceiptConfirmed(params);
        }
    }

}